<template>
  <div class="login-wrap">
    <div class="ms-login">
      <div class="ms-title">{{ this.$route.query.isStatus == 1 ? '注册' : '登录' }}</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ms-content">
        <el-form-item prop="username">
          <el-input v-model="ruleForm.username" placeholder="用户名" maxlength="6" prefix-icon="el-icon-user" ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" show-password placeholder="密码" v-model="ruleForm.password" maxlength="8" prefix-icon="el-icon-lock" @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <div class="login-btn">
          <el-button type="primary" @click="submitForm('ruleForm')">{{ this.$route.query.isStatus == 1 ? '注册' : '登录' }}</el-button>
          <el-button @click="returnPrep">返回</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    var checkPassword = (rule, value, callback)=> {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error(isEnlish?'Password cannot enter Chinese characters':'密码不能输入汉字!'));
        } else {
          callback();
        }
      }
      callback();
    }
    return {
      ruleForm: {
        username: '',
        password: '',
        code:''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {  trigger: 'change' }
          // validator: validateUsername,
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { trigger: 'change', validator: checkPassword }
        ]
      }
    }
  },
  methods: {
    // 返回上一页
    returnPrep() {
      this.$router.go(-1)
    },
    //登录提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("进入登录提交");
          //调用登录接口
          console.log(this.ruleForm.username);
          console.log(this.ruleForm.password);

          //注册
          if(this.$route.query.isStatus == 1){
            this.$message({
              message: '恭喜你，注册成功',
              type: 'success'
            });

            localStorage.setItem('isRegister', 1); //1注册 其他未注册
            localStorage.setItem('isLogin', 1); //1登录 2未登录
            localStorage.setItem('userName', this.ruleForm.username); //用户名
            localStorage.setItem('userPass', this.ruleForm.password) //密码
            this.$router.go(-1)
          }else if(this.$route.query.isStatus == 2) {
            //登录
            //用户名或者密码错误
            if(this.ruleForm.username != localStorage.getItem('userName') || this.ruleForm.password != localStorage.getItem('userPass')){
              this.$message({
                message: '用户名或密码错误',
                type: 'info'
              });
            }else{
              //用户名和密码匹配，登录成功
              this.$message({
                message: '登录成功',
                type: 'success'
              });
              this.$router.go(-1)
              localStorage.setItem('isLogin', 1); //1登录 2未登录
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  mounted() {
    console.log(this.$route.query.isStatus);
  }
}
</script>

<style scoped>
.login-wrap{
  position:fixed;
  width:100%;
  height:100%;
  /*background-image: url(../../assets/img/login-bg.jpg);*/
  /*background-size: 100%;*/
  background:url(../../assets/img/home1920-9100.png) no-repeat center center;
  background-size:100% 100%;
  /*padding-top:25px;*/
}
.swiperImg{
  width:100%;
  height:100%;
  object-fit:cover;
}
/*登录框*/
.ms-login{
  width:350px;
  position: absolute;
  left:45%;
  top:50%;
  margin:-190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255,255,255, 0.9);
  overflow: hidden;
  z-index:10;
}
.ms-title{
  width:100%;
  line-height: 50px;
  text-align: center;
  font-size:20px;
  /*color: #fff;*/
  color:#221815;
  border-bottom: 1px solid #ddd;
}
.ms-content{
  padding: 30px 30px;
}
.login-btn{
  text-align: center;
  display: flex;
  justify-content: space-around;
}
.login-btn button{
  /*width:50%;*/
  /*height:36px;*/
  margin-bottom: 10px;
}
/*验证码*/
.pr {
  position: relative;
}
.code-btn {
  /*width: 100px;*/
  /*height: 32px;*/
  position: absolute;
  /*top: 3px;*/
  right: 10px;
  z-index: 999;
  /*color: #409EFF;*/
  /*font-size: 14px;*/
  /*border: none;*/
  /*border-left: 1px solid #bababa;*/
  /*padding-left: 16px;*/
  /*background-color: #fff;*/
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue